import { Form, Input } from 'antd';
import * as React from 'react';
import { yupSync } from '@/utils/validator';
import formsValidate from '@/utils/validator/formsValidate';
import BaseButton from '@/components/bases/BaseButton';
import i18n from '@/utils/translations/i18n';
import useAuth from '@/stores/auth';

export interface ILoginFormProps {}

export default function LoginForm() {
  const login = useAuth((state) => state.login);

  const onFinish = async (values: { username: string; password: string; remember: boolean }) => {
    login(values);
  };

  return (
    <div className="bg-login w-2/5 p-8">
      <img className="mb-4" src="/images/img_login.png" alt="" />

      <div className="text-3xl uppercase font-bold">{i18n.t('common.login')}</div>

      <Form
        className="mx-auto mt-5 w-full"
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item label={i18n.t('common.username')} name="username" rules={[yupSync(formsValidate.login)]}>
          <Input placeholder="Nhập tài khoản" autoComplete="off" />
        </Form.Item>

        <Form.Item label={i18n.t('common.password')} name="password" rules={[yupSync(formsValidate.login)]}>
          <Input.Password placeholder="Nhập mật khẩu" autoComplete="off" />
        </Form.Item>

        <Form.Item>
          <BaseButton.Primary className="w-full mt-5 uppercase" title={i18n.t('common.login')} />
        </Form.Item>
      </Form>
    </div>
  );
}
